// extracted by mini-css-extract-plugin
module.exports = {"z-index-header":"10","black":"hsl(0, 0%, 0%)","wrapper":"style-module--wrapper--cf7b4f","fullpage":"style-module--fullpage--9cf772"};